import { Input } from '../../../Components'
import { getDateObj, getDateString } from '../../../Services/Functions'
import { cap } from '../../../State'
import { translations } from '../../../translations'
import { DATE_PRESETS } from '../constants'

const language = cap.language.state || 'IT'
const t = translations[language]

/**
 * Sezione periodo: campi data Da/A e chip preset rapidi (Oggi, 7 giorni, 30 giorni, ecc.).
 * @param {Object} props
 * @param {string} props.startDate - Data inizio (dd/mm/yyyy)
 * @param {Function} props.setStartDate - Setter data inizio
 * @param {string} props.endDate - Data fine (dd/mm/yyyy)
 * @param {Function} props.setEndDate - Setter data fine
 * @returns {JSX.Element}
 */
export function StatisticsDateSection({ startDate, setStartDate, endDate, setEndDate }) {
  const handlePresetClick = (preset) => {
    const { start, end } = preset.getRange()
    setStartDate(getDateString(start))
    setEndDate(getDateString(end))
  }

  const isPresetActive = (preset) => {
    const { start, end } = preset.getRange()
    return getDateString(start) === startDate && getDateString(end) === endDate
  }

  return (
    <div className="ncard stats-date-section">
      <div className="ncard__head">
        <div className="ncard__ico">
          <i className="pi pi-calendar" style={{ fontSize: 16 }} />
        </div>
        <div>
          <h3 className="ncard__title">{t.periodo}</h3>
          <div className="ncard__sub">{t.selezionaPeriodoAnalisi}</div>
        </div>
      </div>
      <div className="ncard__body">
        <div className="stats-date-content">
          <div className="nfield nora-date-field stats-date-field" style={{ minWidth: 200 }}>
            <label>{t.dataInizio}</label>
            <Input
              date
              showIcon
              id="startDate"
              value={getDateObj(startDate)}
              onChange={({ startDate: val }) => setStartDate(getDateString(val))}
              style={{ width: '100%' }}
            />
          </div>
          <div className="nfield nora-date-field stats-date-field" style={{ minWidth: 200 }}>
            <label>{t.dataFine}</label>
            <Input
              date
              showIcon
              id="endDate"
              value={getDateObj(endDate)}
              onChange={({ endDate: val }) => setEndDate(getDateString(val))}
              style={{ width: '100%' }}
            />
          </div>
          <div className="stats-date-presets">
            {DATE_PRESETS.map((preset) => (
              <button
                key={preset.label}
                type="button"
                className={`npill ${isPresetActive(preset) ? 'is-active' : ''}`}
                onClick={() => handlePresetClick(preset)}
                tabIndex={0}
                aria-label={`${t.selezionaPeriodoLabel} ${preset.label}`}
              >
                {preset.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
